import { useEffect, useState } from 'react'
import { getSession, onAuthStateChange, signOut } from '@/lib/sessionService'
import { resetSupabase } from '@/lib/integrations/supabase'

export function useAuthSession() {
  const [session, setSession] = useState<any | null>(null)
  const [user, setUser] = useState<any | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let unsub: (() => void) | undefined

    async function loadSession() {
      try {
        const currentSession = await getSession()
        setSession(currentSession)
        setUser(currentSession?.user ?? null)
      } catch (err) {
        console.error('[useAuthSession] getSession error', err)
        setSession(null)
        setUser(null)
      }
    }

    async function init() {
      setLoading(true)
      await loadSession()
      setLoading(false)

      unsub = onAuthStateChange((_event, nextSession) => {
        setSession(nextSession)
        setUser(nextSession?.user ?? null)
      })
    }

    async function handleOnline() {
      try {
        resetSupabase()
        await loadSession()
      } catch (err) {
        console.error('[useAuthSession] error revalidating session on online', err)
      }
    }

    void init()

    window.addEventListener('online', handleOnline)

    return () => {
      window.removeEventListener('online', handleOnline)
      unsub?.()
    }
  }, [])

  return {
    session,
    user,
    loading,
    signOut,
  }
}
